import React, { Component } from 'react';
import { PanelBar, PanelBarUtils, PanelBarItem } from "@progress/kendo-react-layout";
import "./panelBarGL-pure.css";

const PanelBarGLPure = (props) => {
    let {
        children,
        titlePanel,
        expandedPanel,
        id
    } = props

    return (
        <div className='panelBarGLPure-wrapper' id={id}>
            <PanelBar> 
                <PanelBarItem expanded={expandedPanel} title={titlePanel} className='panelBarGLPure-items'>
                    <div className='panelBarGLPure-container-children'>
                        {children}
                    </div>
                </PanelBarItem>    
            </PanelBar>
        </div>
    )
}

export default PanelBarGLPure